import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

type Event = Parameters<typeof trackEvent>[1];

export const trackMainCarouselClick = (
    {
        activeSlide,
        totalSlides,
    }: {
        activeSlide: number;
        totalSlides: number;
    },
    event: Event
): void => {
    const label = `${activeSlide}/${totalSlides}`;
    trackEvent(
        {
            category: 'product',
            action: 'primary image click',
            label,
            eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_PDP,
            step_interaction_name: stepInteractionConstants.STEP_INTERACTION_PRIMARY_IMAGE_CLICK,
            step_type: label,
        },
        event
    );
};

export const trackViewRoomDisplayed = ({
    activeSlide,
    totalSlides,
}: {
    activeSlide: number;
    totalSlides: number;
}): void =>
    trackEvent({
        category: 'product',
        action: 'view in room displayed',
        label: `${activeSlide}/${totalSlides}`,
    });

export const trackArrowClick = ({
    slideType,
    activeSlide,
    totalSlides,
    arrowDirection,
}: {
    slideType: 'photo' | 'viewInRoom' | 'video' | 'requestMore';
    activeSlide: number;
    totalSlides: number;
    arrowDirection: 'next' | 'previous';
}): void => {
    const label =
        slideType === 'requestMore'
            ? 'contact dealer - pdp image carousel'
            : `${activeSlide}/${totalSlides}`;
    trackEvent({
        category: 'product',
        action: `pdp image carousel ${arrowDirection} button`,
        label,
        isInteractiveEvent: true,
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_PDP,
        step_interaction_name: stepInteractionConstants.STEP_INTERACTION_PDP_IMAGE_CAROUSEL,
        trigger: `${arrowDirection} button`,
        step_type: label,
    });
    return;
};
